import Footer from "components/Footer";
import Header from "components/Header";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { singleNewsAction } from "redux/actions/NewsActions/singleNewsActions";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { useTranslation } from "react-i18next";
import NewsCard from "./NewsCard";

const NewsDetails = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  const { id } = useParams();

  useEffect(() => {
    dispatch(singleNewsAction(id));
  }, [dispatch, id]);

  const { newsList, newsListLoading } = useSelector(
    (state: RootState) => state.newsListReducer
  );

  const { singleNewsLoading, singleNews } = useSelector(
    (state: RootState) => state.singleNewsReducer
  );

  // console.log(singleNews);

  return (
    <>
      <Header />

      <main className="relative">
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main title  */}
        <Spin spinning={singleNewsLoading}>
          <section
            style={{
              backgroundImage: `url(${singleNews?.thumbnail_url})`,
            }}
            className="w-full h-[500px] lg:h-[700px]  bg-mainHeader bg-cover bg-center  flex items-center justify-center lg:justify-start"
          >
            <div className="w-full h-full bg-black/75">
              <p
                className={`mainContainer w-full h-full px-[20px] lg:px-0  font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[800] text-[20px] lg:text-[36px] text-first_color flex items-center justify-center `}
              >
                {i18n.language === "en"
                  ? singleNews?.title_en
                  : singleNews?.title_ar}
              </p>
            </div>
          </section>
        </Spin>

        {/* date of the news  */}
        <Spin spinning={singleNewsLoading}>
          <div className="my-[20px]">
            <div
              className={`mainContainer w-full px-[20px] lg:px-0 flex flex-col gap-[20px] font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[700] text-[16px] text-[#444444]`}
            >
              <p>
                {t("Date")}: {singleNews?.created_on.slice(0, 10)}
              </p>
            </div>
          </div>
        </Spin>

        {/* news details  */}
        <Spin spinning={singleNewsLoading}>
          <section className="mt-[20px] mb-[30px] w-full px-[20px] lg:px-0 flex flex-col gap-[20px]">
            <p
              dangerouslySetInnerHTML={{
                __html: `${
                  i18n.language === "en"
                    ? singleNews?.description_en
                    : singleNews?.description_ar
                }`,
              }}
              className={`mainContainer font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[500] text-[18px] text-[#444444]`}
            ></p>
          </section>
        </Spin>

        {/* other news  */}
        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="my-[100px]"
        >
          <div className="mainContainer">
            {/* main header  */}
            <div
              className={`my-[40px] flex items-center justify-center text-second_color text-[32px] font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[600]`}
            >
              <p>{t("Read Another News")}</p>
            </div>

            {/* news Center card section  */}
            <div className="px-[40px] lg:px-0 flex flex-wrap items-center justify-center">
              <div className="w-full grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-4 gap-[20px] lg:gap-[40px]">
                {newsList?.data
                  ?.slice(0, 4)
                  ?.map((singleNews: any, i: number) => {
                    return (
                      <Spin key={i} spinning={newsListLoading}>
                        <NewsCard data={singleNews} />
                      </Spin>
                    );
                  })}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default NewsDetails;
